import React from 'react';
import './Footer.css';

const Footer = () => {
  const appName = process.env.REACT_APP_NAME || 'UltraCoder IDE';
  const appVersion = process.env.REACT_APP_VERSION || '2.0.0';
  const githubUrl = process.env.REACT_APP_GITHUB_URL || '#';
  const docsUrl = process.env.REACT_APP_DOCS_URL || '#';
  const websiteUrl = process.env.REACT_APP_WEBSITE_URL || '#';
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@ultracoder.dev';
  const currentYear = new Date().getFullYear();

  const links = {
    Product: [
      { label: 'Features', href: '#features' },
      { label: 'Pricing', href: '#' },
      { label: 'Changelog', href: '#' },
      { label: 'Roadmap', href: '#' },
    ],
    Resources: [
      { label: 'Documentation', href: docsUrl },
      { label: 'API Reference', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Tutorials', href: '#' },
    ],
    Company: [
      { label: 'About', href: '#about' },
      { label: 'Careers', href: '#' },
      { label: 'Press', href: '#' },
      { label: 'Contact', href: `mailto:${supportEmail}` },
    ],
    Community: [
      { label: 'GitHub', href: githubUrl },
      { label: 'Discord', href: '#' },
      { label: 'Twitter / X', href: '#' },
      { label: 'YouTube', href: '#' },
    ],
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <span>⚡</span>
            </div>
            <div className="footer__brand-text">
              <span className="footer__brand-name">{appName}</span>
              <span className="footer__brand-version">v{appVersion}</span>
            </div>
          </div>
          <p className="footer__tagline">
            The AI-powered development environment built for the modern era of software engineering.
          </p>
          <div className="footer__env-badge">
            <span className="footer__env-dot"></span>
            ENV: {process.env.REACT_APP_ENV || 'development'} · API: {process.env.REACT_APP_API_VERSION || 'v2'}
          </div>
        </div>

        <div className="footer__links">
          {Object.entries(links).map(([category, items]) => (
            <div key={category} className="footer__link-group">
              <h4 className="footer__link-group-title">{category}</h4>
              <ul>
                {items.map((item, i) => (
                  <li key={i}>
                    <a href={item.href} target={item.href.startsWith('http') ? '_blank' : '_self'} rel="noreferrer">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} {appName}. All rights reserved.
          </p>
          <div className="footer__bottom-links">
            <a href={websiteUrl} target="_blank" rel="noreferrer">Privacy Policy</a>
            <a href={websiteUrl} target="_blank" rel="noreferrer">Terms of Service</a>
            <a href={websiteUrl} target="_blank" rel="noreferrer">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;